$shm_hitalama_app $mol_view
	title \Hitalama
	map $shm_hitalama_map
	maps_list_visible? true
	projects_list_visible? true
	chat_width? 432
	plugins /
		<= Theme $mol_theme_auto
	auto /
		^
		<= pass_income_auto null
		<= telemetry_auto null
		<= master_link
		<= baza_sync_auto null
		<= entergate_pending_auto null
		<= client_pass_publish_auto null
		<= mcp_client_auto null
		<= projects_session_identity_auto null
		<= projects_team_config_auto null
		<= profile_name_publish_auto null
		<= workspace_auto /
		<= selfhosted_tauri_admin_auto null
	command_palette_keydown_listener $shm_listener /
		\keydown
		<= command_palette_keydown_handler null
		<= document null
		* passive false
	Baza_status $giper_baza_status
		master_link => master_link
	sub /
		<= Book
		^ map_version_notice /
		<= Command_palette $shm_hitalama_map_command_palette
			opened? <=> command_palette_opened? false
		<= Right_bottom_panel $mol_view
			sub /
				<= History_toggle $mol_check_icon
					hint \История изменений
					Icon <= History_toggle_icon $mol_icon_history
					checked? <=> history_opened? false
				<= Process_monitor_toggle $mol_check_icon
					hint \Process monitor
					Icon <= Process_monitor_toggle_icon $mol_icon_clock_fast
					checked? <=> process_monitor_opened? false
				<= Speech $shm_hitalama_speech
				<= Mbutton $shm_hitalama_mbutton
					checked? <=> chat_opened? false
		<= Fullscreen $shm_hitalama_app_fullscreen
			map_book <= Map
			overlay_panel <= Overlay_panel
		<= Overlay_panel $shm_hitalama_app_overlay
		<= Hotkeys $shm_hotkey
			scope \hitalama
			root <= dom_node
	Map_version $shm_hitalama_version_label
		version <= version_data_version
		date <= version_data_date
		available_version <= version_data_available
	Book $shm_hitalama_app_book
		maps_list_visible? <=> maps_list_visible?
		projects_list_visible? <=> projects_list_visible?
		param \section
		menu_title \Hitalama
		menu_tools /
			<= Status $giper_baza_status
			<= Lights $mol_lights_toggle
		menu_foot /
			<= Footer $shm_hitalama_footer
				version <= version_data_version \-
				date <= version_data_date \-
				available_version <= version_data_available \-
		placeholders /
		Menu => Book_menu
		spread => spread
		Spread* => Spread*
		Spread_default => Spread_default
		pages <= book_pages /
			<= Book_menu
			<= Main $mol_page
				head /
					<= Tokens $mol_view
						sub /
							<= Tokens_label $mol_text
								text \Сбор осуществляется от имени
							<= Token_switch $shm_hitalama_vk_token_switch
								current => token
					<= Profile $shm_hitalama_profile_switch
				body / <= Spread_current $mol_view
			^ side_views /
		spreads <= menu_spreads
	menu_spreads *
		\
			<= Analysis $shm_hitalama_components_embed
				title \Сбор и анализ постов
				fqn <= analysis_fqn \
		lists <= Lists $shm_hitalama_vk_lists
			token <= token
		maps <= Maps $shm_hitalama_map_catalog
			maps_list_visible? <=> maps_list_visible?
		projects <= Projects $shm_hitalama_projects
			menu_title \Проекты
			projects_list_visible? <=> projects_list_visible?
			maps <= Maps
		applications <= Applications $shm_hitalama_components
		skills <= Skills $shm_hitalama_skills
		knowledge <= Knowledge $shm_knowledge
		team <= Teams $shm_hitalama_teams
		duckdb_page <= Duckdb $shm_hitalama_duckdb_page
		benchmark <= Benchmark $shm_hitalama_benchmarks_page
			version <= version_data_version \-
		settings <= Settings $shm_hitalama_settings
		profile <= Profile_page $shm_hitalama_profile_page
			profiles <= profiles
	Components <= Applications
	Guide $shm_hitalama_guide_panel
		section <= guide_section \
		param \help_page
	Auth_gate $shm_hitalama_entergate_app
	Recovery_page* $shm_hitalama_resilience_page
		title <= recovery_title* \Раздел временно недоступен
		message <= recovery_message* \Не удалось загрузить данные. Остальные разделы продолжают работать.
		details <= recovery_details* \
		retry_visible <= recovery_retry_visible* true
	Enter $shm_hitalama_profile_enter
		profiles <= profiles $shm_hitalama_profile_dict
	Register $shm_hitalama_profile_register
		profiles <= profiles
	no_auth_pages *
		domain_page <= Domain_page $shm_hitalama_domain_page
	Map $shm_hitalama_map_book - \from Maps
	-
		entity <= map $shm_hitalama_map
	Ext $shm_hitalama_extension_app
	Chat $shm_hitalama_agent_map_chat
		width? <=> chat_width?
		map_id <= agent_map_id \
	Map_codex $shm_hitalama_codex_map
		width? <=> chat_width?
		map_id <= agent_map_id
	General_chat $shm_hitalama_agent_general
		width? <=> chat_width?
	General_codex $shm_hitalama_codex_general
		width? <=> chat_width?
	Project_chat $shm_hitalama_project_codex
		width? <=> chat_width?
	Process_monitor $shm_hitalama_process_monitor_maps
		close? <=> process_monitor_close? null
	History $shm_hitalama_map_history_view
		map <= map
		close? <=> history_close? null
